import React, { useState } from 'react';
import { useEffect } from 'react';
import step1 from '../../images/step-1.webp'
import step4 from '../../images/step-4.webp'

const EducationDetails = ({ nextStep, prevStep, handleChange, values }) => {

    const [isDisabled, setIsDisabled] = useState(true);

    useEffect( () =>  {
        if (values.degree && values.school && values.industry && values.interestedIn && values.classification && values.about ) {
            setIsDisabled(false);
        } else {
            setIsDisabled(true);
        }
    }, [values])

    const buttons = (
      <>
        <button
          onClick={prevStep}
          className="mt-3 btn btn-outline-primary rounded-0 px-5 mr-3"
        >
          Back
        </button>
        <button
          onClick={nextStep}
          disabled={isDisabled}
          className={`mt-3 btn btn-primary rounded-0 px-5 ${
            isDisabled ? "btn_disabled" : ""
          }`}
        >
          Next
        </button>
      </>
    );

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-12 col-lg-5 text-left mt-0 mt-lg-5 mb-3 mb-lg-0">
            <h2
              className="mb-3"
              style={{ fontSize: "clamp(26px, 5vw, 34px)", fontWeight: "700" }}
            >
              Final Step: Complete Your Professional Profile
            </h2>

            <p style={{ fontSize: "clamp(15px, 5vw, 18px)" }}>
              Almost done! Only a few more questions to get started on the 3For3
              Networking Platform.
            </p>

            <div className="d-none d-lg-block">{buttons}</div>
          </div>

          <div className="col-12 col-lg-7">
            <div className="rounded-container">
              {/* <h5 className='mb-3'>Education</h5> */}
              <div className="form-row">
                <div className="col-12 col-md-6 mb-3">
                  <label>
                    Degree <span className="text-danger">*</span>
                  </label>
                  {/* <input type="text" value={values.degree} onChange={handleChange('degree')}  className="form-control" placeholder="Enter Your Degree" /> */}
                  <select
                    className="form-control"
                    value={values.degree}
                    onChange={handleChange("degree")}
                  >
                    <option value="">Select your degree</option>
                    <option value="No formal education">
                      No formal education
                    </option>
                    <option value="High school GED">High school GED</option>
                    <option value="Vocational qualification">
                      Vocational qualification
                    </option>
                    <option value="Some College">Some College</option>
                    <option value="Associate degree">Associate degree</option>
                    <option value="Bachelor's degree">Bachelor's degree</option>
                    <option value="Master's degree">Master's degree</option>
                    <option value="Doctoral degree">Doctoral degree</option>
                  </select>
                </div>
                <div className="col-12 col-md-6 mb-3">
                  <label>
                    School <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    maxLength={50}
                    value={values.school}
                    onChange={handleChange("school")}
                    className="form-control"
                    placeholder="Enter School Name"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="col-12 col-md-6 mb-3">
                  <SelectInput
                    label="Industry"
                    name="industry"
                    value={values.industry}
                    firstOption="Select Industry"
                    required={true}
                    onChange={handleChange("industry")}
                    options={industriesOptions}
                  />
                </div>
                <div className="col-12 col-md-6 mb-3">
                  <SelectInput
                    label="Interested In"
                    name="interested_in"
                    value={values.interestedIn}
                    firstOption="Select Your Interest"
                    required={true}
                    onChange={handleChange("interestedIn")}
                    options={["Mentoring", "Networking", "Business"]}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="col-12 col-md-6 mb-3">
                  <SelectInput
                    label="Classification"
                    name="classification"
                    value={values.classification}
                    firstOption="Select Classification"
                    required={true}
                    onChange={handleChange("classification")}
                    options={["Student", "Professional", "Business Owner"]}
                  />
                </div>
                <div className="col-12 col-md-6 mb-3">
                  <label>Website Link (Optional) </label>
                  <input
                    type="text"
                    value={values.linkedinUrl}
                    onChange={handleChange("linkedinUrl")}
                    className="form-control"
                    placeholder="Enter URL"
                    maxLength={200}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="col-12">
                  <label>
                    About <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    value={values.about}
                    onChange={handleChange("about")}
                    name="about"
                    placeholder="You can write about your years of experience, industry, or skills. People also talk about their achievements or previous job experiences."
                    rows="7"
                    spellCheck="false"
                    maxLength={1000}
                  ></textarea>
                </div>
              </div>
            </div>
            <div className="d-block d-lg-none mt-3 mt-lg-0">{buttons}</div>
          </div>
        </div>
      </React.Fragment>
    );
}

export default EducationDetails;

export const SelectInput = ({
    label,
    name,
    firstOption,
    required,
    options,
    value,
    onChange
}) => {
    return (
      <>
        <label>
          {label} {required ? <span className="text-danger">*</span> : null}
        </label>
        <select
          name={name}
          value={value}
          required={required}
          onChange={onChange}
          className="form-control"
        >
          <option value="">{firstOption}</option>
          {options?.length > 0 &&
            options.map((item, index) => (
              <option key={`${index}-${item}`} value={item}>
                {item}
              </option>
            ))}
        </select>
      </>
    );
};

const industriesOptions = ["Accounting", "Airlines/Aviation", "Alternative Dispute Resolution", "Alternative Medicine", "Animation", "Apparel & Fashion", "Architecture & Planning", "Arts and Crafts", "Automotive", "Aviation & Aerospace", "Banking", "Biotechnology", "Broadcast Media", "Building Materials", "Business Supplies and Equipment", "Capital Markets", "Chemicals", "Civic & Social Organization", "Civil Engineering", "Commercial Real Estate", "Computer & Network Security", "Computer Games", "Computer Hardware", "Computer Networking", "Computer Software", "Construction", "Consumer Electronics", "Consumer Goods", "Consumer Services", "Cosmetics", "Dairy", "Defense & Space", "Design", "Education Management", "E-Learning", "Electrical/Electronic Manufacturing", "Entertainment", "Environmental Services", "Events Services", "Executive Office", "Facilities Services", "Farming", "Financial Services", "Fine Art", "Fishery", "Food & Beverages", "Food Production", "Fund-Raising", "Furniture", "Gambling & Casinos", "Glass, Ceramics & Concrete", "Government Administration", "Government Relations", "Graphic Design", "Health, Wellness and Fitness", "Higher Education", "Hospital & Health Care", "Hospitality", "Human Resources", "Import and Export", "Individual & Family Services", "Industrial Automation", "Information Services", "Information Technology and Services", "Insurance", "International Affairs", "International Trade and Development", "Internet", "Investment Banking", "Investment Management", "Judiciary", "Law Enforcement", "Law Practice", "Legal Services", "Legislative Office", "Leisure, Travel & Tourism", "Libraries", "Logistics and Supply Chain", "Luxury Goods & Jewelry", "Machinery", "Management Consulting", "Maritime", "Market Research", "Marketing and Advertising", "Mechanical or Industrial Engineering", "Media Production", "Medical Devices", "Medical Practice", "Mental Health Care", "Military", "Mining & Metals", "Motion Pictures and Film", "Museums and Institutions", "Music", "Nanotechnology", "Newspapers", "Non-Profit Organization Management", "Oil & Energy", "Online Media", "Outsourcing/Offshoring", "Package/Freight Delivery", "Packaging and Containers", "Paper & Forest Products", "Performing Arts", "Pharmaceuticals", "Philanthropy", "Photography", "Plastics", "Political Organization", "Primary/Secondary Education", "Printing", "Professional Training & Coaching", "Program Development", "Public Policy", "Public Relations and Communications", "Public Safety", "Publishing", "Railroad Manufacture", "Ranching", "Real Estate", "Recreational Facilities and Services", "Religious Institutions", "Renewables & Environment", "Research", "Restaurants", "Retail", "Security and Investigations", "Semiconductors", "Shipbuilding", "Sporting Goods", "Sports", "Staffing and Recruiting", "Supermarkets", "Telecommunications", "Textiles", "Think Tanks", "Tobacco", "Translation and Localization", "Transportation/Trucking/Railroad", "Utilities", "Venture Capital & Private Equity", "Veterinary", "Warehousing", "Wholesale", "Wine and Spirits", "Wireless", "Writing and Editing"]
